import script from "./branchsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./branchsPage.vue?vue&type=script&setup=true&lang=js"

import "./branchsPage.vue?vue&type=style&index=0&id=30c86838&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30c86838"]])

export default __exports__